/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".disp-inlineblk[_ngcontent-%COMP%]{display:inline-block}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/access-management/users/user-details/user-details-roles-tab-add/user-details-roles-tab-add.component.scss.shim.ngstyle.js.pre-build-optimizer.js